<script setup>

import router from '@/router';
import {getIpAPI} from "@/apis/user"
import menuView from "@/components/menuView/index.vue"
import customerService from "@/views/customerService/index.vue"
import { useUserStore } from '@/stores/userStore'
import { useI18n } from 'vue-i18n'
const i18n = useI18n()
const userStore = useUserStore()
const currentRoute = ref(router.currentRoute.value.path);
const lang = ref()


const zhi = ref('');
onBeforeUnmount(() => {
    userStore.serviceStatus=false
});
onMounted(() => {
    const code=localStorage.getItem('countryCode')
    console.log(code)
    if(code){
        // setLang(code)
        zhi.value=localStorage.getItem('language')
        lang.value=localStorage.getItem('language')
    }else{
        getIp(); 
    }
    // getIp();
})
const getIp=async ()=>{
    console.log('ip')
    const res = await getIpAPI()
    if(res.code==0){
        console.log('ip2')
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log('shiqu',timeZone)
        // console.log('ip:',res.data.ip)
        userStore.ipTime=timeZone
        userStore.userIp=res.data.ip
        localStorage.setItem('countryCode', res.data.countryCode);
        // fetchIPInfo(res.data.ip)
        const countryCode=localStorage.getItem('countryCode')
    //    if(countryCode){
    console.log(res.data.countryCode)
            setLang(res.data.countryCode)
    //    }
       
    }
    
}

//根据ip判断显示那种语言
const setLang=(code)=>{
    console.log('判断语言')
    if(code=='ARG' ||code=='COL' ||code=='MEX' ||code=='ESP'||code=='CHL'){//西班牙
        localStorage.setItem('language', 'ESP');
        i18n.locale.value = 'ESP'
        lang.value = 'ESP'
        zhi.value='ESP'
    }else if(code=='BR'){//葡萄牙语
        localStorage.setItem('language', 'PCP');
        i18n.locale.value = 'PCP'
        lang.value = 'PCP'
        zhi.value='PCP'
    }else if(code=='BEL'||code=='NL'){//荷兰
        localStorage.setItem('language', 'NED');
        i18n.locale.value = 'NED'
        lang.value = 'NED'
        zhi.value='NED'
    }else if(code=='POL'){//波兰语
        localStorage.setItem('language', 'PL');
        i18n.locale.value = 'PL'
        lang.value = 'PL'
        zhi.value='PL'
    }else if(code=='DE'){//德语
        localStorage.setItem('language', 'DE');
        i18n.locale.value = 'DE'
        lang.value = 'DE'
        zhi.value='DE'
    }else if(code=='FRA'){//法语
        localStorage.setItem('language', 'PCF');
        i18n.locale.value = 'PCF'
        lang.value = 'PCF'
        zhi.value='PCF'
    }else if(code=='ITA'){//意大利
        localStorage.setItem('language', 'Ita');
        i18n.locale.value = 'Ita'
        lang.value = 'Ita'
        zhi.value='Ita'
    }else if(code=='CHN' ||code=='HK'){
        localStorage.setItem('language', 'ZN');
        i18n.locale.value = 'ZN'
         lang.value = 'ZN'
        zhi.value='ZN'
    }else{
        localStorage.setItem('language', 'en_US');
        i18n.locale.value = 'en_US'
        lang.value = 'en_US'
        zhi.value='en_US'
    }
    console.log('语言-',code)
}
// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {
        currentRoute.value = newPath;
    }
);
console.log('每次进入页面',import.meta.env.VITE_APP_API_URL)


// 1.获去当前人的ip地址
// let deferredPrompt = null;
// window.addEventListener('beforeinstallprompt', (e) => {
//     console.log('beforeinstallprompt1')
//     e.preventDefault();
//     deferredPrompt = e;
//   });
  // 添加一个按钮，用户点击时触发安装
// const btn = document.createElement('button');
// btn.innerHTML = '添加到主屏幕';
// btn.style.position = 'fixed';
// btn.style.bottom = '20px';
// btn.style.right = '20px';
// btn.addEventListener('click', () => {
//     // alert('zhi',deferredPrompt)
//     if (deferredPrompt) {
//         deferredPrompt.prompt();
       
//         deferredPrompt.userChoice.then((choiceResult) => {
           
//               if (choiceResult.outcome === 'accepted') {
//                 console.log('用户接受了添加到主屏幕');
//                 // 执行添加到主屏幕后的相关操作
//               } else {
//                 console.log('用户拒绝了添加到主屏幕');
//                 // 执行用户拒绝后的相关操作，例如显示提示或者隐藏添加按钮
//               }
//               deferredPrompt = null;
//             });
//           } else {
//             console.log('没有可用的 deferredPrompt 事件');
//           }
// });
// document.body.appendChild(btn);
</script>

<template>
     <metainfo></metainfo>
    <!-- <el-button type="primary">Primary</el-button> -->
    <!-- 一级路由出口组件 -->
    <menuView v-if="currentRoute != '/login'"></menuView>
    <customerService v-if="userStore.serviceStatus && userStore.userInfo.token"></customerService>
    <RouterView :key="router.currentRoute.value.fullPath"/>
</template>

<style scoped lang="scss">

.test {
    color: $priceColor;
}

header {
    line-height: 1.5;
    max-height: 100vh;
}

.logo {
    display: block;
    margin: 0 auto 2rem;
}

nav {
    width: 100%;
    font-size: 12px;
    text-align: center;
    margin-top: 2rem;
}

nav a.router-link-exact-active {
    color: var(--color-text);
}

nav a.router-link-exact-active:hover {
    background-color: transparent;
}

nav a {
    display: inline-block;
    padding: 0 1rem;
    border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
    border: 0;
}

@media (min-width: 1024px) {
    header {
        display: flex;
        place-items: center;
        padding-right: calc(var(--section-gap) / 2);
    }

    .logo {
        margin: 0 2rem 0 0;
    }

    header .wrapper {
        display: flex;
        place-items: flex-start;
        flex-wrap: wrap;
    }

    nav {
        text-align: left;
        margin-left: -1rem;
        font-size: 1rem;

        padding: 1rem 0;
        margin-top: 1rem;
    }
}
</style>
